export default "__VITE_ASSET__uUmoR5ub__"